<template>
    <el-dialog
            :title="'详情'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form  ref="dataForm"
                  label-width="150px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="工号" prop="workNumber">
                        <div class="min-input-class">{{dataForm.workNumber}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="用户名" prop="userId">
                        <div class="min-input-class">{{dataForm.userName}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="大队" prop="bmmc">
                        <div class="min-input-class">
                            <el-tag>{{dataForm.bmmc}}</el-tag>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="岗点" prop="gdmc">
                        <div class="min-input-class">
                            <el-tag type="success">{{dataForm.gdmc}}</el-tag>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="巡逻点" prop="placeId">
                        <div class="min-input-class">
                            <el-tag type="warning">{{dataForm.plcaeName}}</el-tag>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="时间" prop="time">
                        <div class="min-input-class">
                          {{dataForm.time}}
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注" prop="bz">
                        <div class="min-input-class">
                          {{dataForm.bz}}
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="dataForm.status==1">
                <el-col :span="12">
                    <el-form-item label="图片">
                        <el-image :src="dataForm.photo">
                            <div slot="error" class="image-slot">
        暂无图片
      </div>
                        </el-image>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="位置">
                        <div class="amap-page-container">
                            <el-amap ref="map" vid="amapDemo" :amap-manager="amapManager" :center="center" :zoom="zoom.zoom"  class="amap-demo"
                                     style="position: relative;" :events="events">

                                <el-amap-marker :vid="marker.id" v-for="marker in markersGd" :position="marker.position" :events="marker.events"></el-amap-marker>
                                <el-amap-marker :vid="marker.id"  v-for="marker in markerPatrol"  :position="marker.position" :events="marker.events" :icon="icon"></el-amap-marker>

                                <el-amap-circle  fill-color="#6495ED" v-for="circle in circles" :radius="circle.radius" :fill-opacity="circle.fillOpacity"
                                                :center="circle.center" :events="circle.events"></el-amap-circle>
                                <el-amap-info-window  :position="window.position" :visible="window.visible" :offset="[0,-20]">
                                    <div>
                                        <div class="MapPopBox">
                                            <div class="DeviceInfo">
                                                <div class="item">
                                                    <ul>
                                                        <li>
                                                            <span class="item-title">{{window.info.type=='gd'?'岗点：':'巡逻点：'}}</span>
                                                            <span class="item-info" :title="window.info.name" v-text="window.info.name"></span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-amap-info-window>
                            </el-amap>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import VueAMap from 'vue-amap'
    import markr from '../../../assets/bjba/map/mark_r.png'
    export default {
        components: {},
        data () {
            return {
                visible: false,
                dataForm: {},
                amapManager: new VueAMap.AMapManager(),
                markersGd:[],
                markerPatrol:[],
                circle:'',
                window: {
                    position:[121.506377, 31.245105],
                    visible: false,
                    info: {}
                },
                zoom: {
                    zoom: 12
                },
                events: {
                    zoomchange: (e) => {
                        this.zoom.zoom=this.$refs.map.$$getInstance().getZoom()
                    }
                },
                center: [121.506377, 31.245105],
                circles:[],
                icon:markr
            }
        },
        methods: {
            init (obj) {
                if(!obj) return;
                this.visible = true
                this.$nextTick(() => {
                    this.dataForm = obj
                    this.getGdxx()
                    this.getPhoto()
                })

            },
            getPhoto() {
                this.$http({
                    url: `/bjba/tpatrollog/info/${this.dataForm.id}`,
                    method: 'get'
                }).then(res => {
                    this.dataForm.photo = 'data:image/jpeg;base64,'+res.data.data.photo
                })
            },
            getGdxx() {
                this.$http({
                    url: `/bjba/map/info/${this.dataForm.gdid}`,
                    method: 'get'
                }).then(({data}) => {
                    this.markersGd.splice(0,this.markersGd.length)
                    this.markerPatrol.splice(0,this.markerPatrol.length)
                    this.circles.splice(0,this.circles.length)
                    var _that = this;
                    if(data.gd) {

                       let marker = [ data.gd.zbjd, data.gd.zbwd];
                       let marker2 = [ this.dataForm.lon, this.dataForm.lat];
                       let newmarker = {
                            position: marker,
                            vid: data.gd.gdid,
                            events: {
                                mouseover:(e) => {
                                    _that.window.visible = false
                                    this.$nextTick(() => {
                                        _that.window.info.name = data.gd.gdmc
                                        _that.window.info.type = 'gd'
                                        _that.window.visible = true
                                        _that.window.position = marker
                                    })
                                },
                                mouseout:(e) => {
                                    // this.form.x = e.lnglat.lng;
                                    // this.form.y = e.lnglat.lat;
                                    // console.log(_that.markers);
                                    _that.window.visible = false
                                    this.$nextTick(() => {

                                        // _that.window.info = element
                                        _that.window.visible = false
                                        // _that.window.position = [element.lng, element.lat]
                                    })
                                }
                            }
                        };
                       this.markersGd.push(newmarker)
                       let newcircle = {
                            center: marker,
                            radius: data.gd.dkjl,
                            fillOpacity: 0.5,
                            events: {
                                click: (e) => {
                                }
                            }
                        }
                       this.circles.push(newcircle) ;
                       this.center = marker
                       this.zoom.zoom=15

                       let newmarker2 = {
                            position: marker2,
                            vid: this.dataForm.id,
                            events: {
                                mouseover:(e) => {
                                    _that.window.visible = false
                                    this.$nextTick(() => {
                                        _that.window.info.name = this.dataForm.plcaeName
                                        _that.window.info.type = 'pl'
                                        _that.window.visible = true
                                        _that.window.position = marker2
                                    })
                                },
                                mouseout:(e) => {
                                    _that.window.visible = false
                                    this.$nextTick(() => {
                                        _that.window.visible = false
                                    })
                                }
                            }
                        };
                       this.markerPatrol.push(newmarker2)
                    }

                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
    .amap-page-container {
        height: 500px;
        width: 100%;
        margin: 0.5rem 0.5rem 0.5rem 0.5rem;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
</style>
